import { Button } from 'components/Button';
import SwalContent from 'components/SwalContent';
import { modals } from '@/copy';
import { useModal } from '@ebay/nice-modal-react';
import { useState } from 'react';

function FlagModalContent({ onSubmit }) {
    const [comment, setComment] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const modal = useModal();
    return (
        <SwalContent.ThemeWrapper
            as="form"
            onSubmit={(e) => {
                e.preventDefault();
                setIsSubmitting(true);
                onSubmit(comment);
            }}
        >
            <h1>{modals.flagModals.flagModal.content.title}</h1>
            <label htmlFor="flag-comment">comments (optional):</label>
            <textarea
                id="flag-comment"
                maxLength={1000}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder={modals.flagModals.flagModal.content.placeholder}
                disabled={isSubmitting}
                css={`
                    min-height: 100px;
                    resize: vertical;
                `}
            />
            <SwalContent.ButtonBar>
                <Button
                    intent="secondary"
                    onClick={() => modal.hide()}
                    disabled={isSubmitting}
                    fetching={isSubmitting}
                >
                    {modals.flagModals.flagModal.cancel}
                </Button>
                <Button
                    css={`
                        margin-left: ${({ theme }) => theme.space_4}px;
                    `}
                    intent="primary"
                    disabled={isSubmitting}
                    fetching={isSubmitting}
                    type="submit"
                >
                    {modals.flagModals.flagModal.confirm}
                </Button>
            </SwalContent.ButtonBar>
        </SwalContent.ThemeWrapper>
    );
}

export default FlagModalContent;
